import { StyleSheet } from '@react-pdf/renderer'
import { styleConfig } from '../config'
const { fontSize } = styleConfig
//
import '../../utils/fonts'

const fullWidth = 190
const leftWidth = 60
const centerWidth = 65
const rightWidth = 65

const styles = StyleSheet.create({
	headerOrganization: {
		display: 'flex',
		flexDirection: 'row',
		width: `${fullWidth}mm`,
		marginBottom: 21,
		height: '32mm',
	},
	headerOrganizationLeft: {
		width: `${leftWidth}mm`,
		paddingTop: '5mm',
	},
	headerOrganizationCenter: {
		width: `${centerWidth}mm`,
		paddingVertical: `${fontSize / 2}mm`,
		paddingLeft: '2mm',
		paddingRight: `${fontSize / 2}mm`,
	},
	headerOrganizationRight: {
		width: `${rightWidth}mm`,
		paddingVertical: `${fontSize / 2}mm`,
		paddingHorizontal: '2mm',
	},
	headerDocTitle: {
		fontFamily: 'Inter',
		fontSize: fontSize * 2,
		paddingVertical: '2mm',
		paddingHorizontal: '2mm',
		flexDirection: 'row',
	},
	headerInner: {
		paddingHorizontal: '2mm',
		paddingVertical: '1mm',
	},
	headerCustomerRow: {
		display: 'flex',
		flexDirection: 'row',
		minHeight: '42mm',
	},
	headerCustomerLeft: {
		width: `${fullWidth / 2}mm`,
	},
	headerCustomerRight: {
		width: `${fullWidth / 2}mm`,
		flexDirection: 'column',
	},
	detailsTop: {
		flex: 1,
	},
	detailsBottom: {
		height: '10mm',
	},
	headerTitle: {},
	/**
	 * components
	 */
	verify: {
		width: '25mm',
		height: '25mm',
	},
	text: {
		fontSize,
	},
	textBold: {
		fontSize,
		fontFamily: 'Inter',
		fontWeight: 'bold',
	},
	image: {
		maxWidth: `${leftWidth - 15}mm`,
		objectFit: 'contain',
		maxHeight: `24mm`,
		width: 'auto',
		height: 'auto',
		alignSelf: 'flex-start',
	},
	title: {
		fontSize: fontSize * 1.4,
		fontFamily: 'Inter',
	},
	detailsRow: {
		display: 'flex',
		flexDirection: 'row',
	},
	detailsRowTitle: {
		width: '28mm',
	},
	detail: {},
})

export default styles
